import BaseService from "./_base.service";
import API from "../api";
import { AxiosResponse } from "axios";
import { ChainReport, GenerateReport, GenerateReportResponse } from "../models/chain.report";

const endpoint = "chain/reports";

export const ChainReportService = {
  ...BaseService<ChainReport>({ endpoint }),
  async sendMail(data: ChainReport, options: any): Promise<AxiosResponse<ChainReport>> {
    return API.post(`/${endpoint}/mail`, data, { params: options });
  },
  async generateReport(
    data: GenerateReport,
    options: any
  ): Promise<AxiosResponse<GenerateReportResponse>> {
    return API.post(`/${endpoint}/generate`, data, { params: options });
  },
};
